import { createSelector } from 'reselect';
export const productDataSelector = ({
  abstractedProducts
}) => {
  return abstractedProducts;
};
export const transformState = createSelector(
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore ignore the error where useSelector is limited to 12 selectors
[productDataSelector], productData => ({
  productData
}));